// src/layout/realestateagent/Profile/AgentBanner.jsx
import React, { useState } from "react";
import AgentDetails from "./AgentDetails";
import calculateAgentProfileCompletion from "./calculateAgentProfileCompletion";

const AgentBanner = ({ name, role, housingCount = 0, plotCount = 0 }) => {
    const [activeTab, setActiveTab] = useState("profile");
    const [profileCompletion, setProfileCompletion] = useState(100);

    const handleProfileChange = (profileData) => {
        const completion = calculateAgentProfileCompletion(profileData);
        setProfileCompletion(completion);
    };

    return (
        <>
            <div className="bg-gray-100 overflow-hidden shadow rounded-2xl text-sm">
                <div className="relative px-5 py-2 bg-white flex flex-col sm:flex-row items-start sm:items-center justify-between min-h-[100px]">
                    <div className="ml-4 pt-4 pb-4">
                        <h2 className="text-base font-semibold">
                            {name || "Agent Name"}
                        </h2>
                        <p className="text-gray-600 flex items-center space-x-2 text-sm">
                            <span>{role || "Real Estate Agent"}</span>
                        </p>
                        <div className="mt-2 text-xs text-gray-500">
                            <span className="font-medium text-blue-600">{housingCount}</span> Houses Posted | <span className="font-medium text-green-600">{plotCount}</span> Plots Posted
                        </div>
                    </div>
                    <div className="ml-4 sm:ml-0 sm:mr-8 pt-4 pb-4">
                        <div className="h-1.5 bg-gray-200 rounded-full w-32">
                            <div
                                className="h-full bg-blue-500 rounded-full"
                                style={{ width: `${profileCompletion}%` }}
                            ></div>
                        </div>
                        <p className="text-xs text-gray-500 mt-1">{profileCompletion}% Complete</p>
                    </div>
                </div>

                <div className="relative bg-white pt-2">
                    <ul className="flex justify-start gap-6 text-gray-600 w-full px-4 text-sm">
                        <li
                            className={`cursor-pointer px-4 py-2 h-full ${activeTab === "profile" ? "bg-gray-300" : "hover:bg-[#E0E0E0]"
                                }`}
                            style={{ borderRadius: "10px 10px 0 0" }}
                            onClick={() => setActiveTab("profile")}
                        >
                            Profile
                        </li>
                    </ul>
                </div>
            </div>

            <div className="mt-4 p-4 bg-white shadow-md rounded-2xl text-sm">
                {activeTab === "profile" && <AgentDetails onProfileChange={handleProfileChange} />}
            </div>
        </>
    );
};

export default AgentBanner;
